import * as types from './types'
import { dropService } from '@/_services'
import { orderHelpers, dropHelpers } from '@/_helpers'
import i18n from '@/i18n'
import { locationService } from '../../../_services/location.service'

const actions = {
  selectItem ({ commit }, { itemID, details }) {
    commit(types.SELECT_ITEM, { itemID, details })
    dropService.getDrop({ id: itemID }).then((response) => {
      commit(types.SELECT_DROP_DETAILS_VIEW, { drop: response.data.getDrop.drop })
      commit(types.UPDATE_ITEM, { units: response.data.getDrop.children })
    }).catch((error) => {
      console.log(error)
    })
  },
  changeActualPage ({ commit }, page) {
    commit(types.CHANGE_ACTUAL_PAGE, page)
  },
  toggleAll ({ commit }, data) {
    commit(types.TOGGLE_ALL, data)
  },
  toggleItem ({ commit }, data) {
    commit(types.TOGGLE_ITEM, data)
  },
  addDropUnits ({ commit }, { dropID }) {
    commit(types.LOADING_NEW_DROPS, { isLoading: true, isExportLoading: true })
    dropService.getDrop({ id: dropID }).then((response) => {
      commit(types.ADD_DROP_UNITS, { units: response.data.getDrop.children, isTree: false })
      commit(types.SELECT_DROP_DETAILS_VIEW, { drop: { ...response.data.getDrop.drop, units: response.data.getDrop.children } })
      commit('UPDATE_SELECTED_RESOURCE', { resource: { ...response.data.getDrop.drop, objectID: response.data.getDrop.id, units: [] } })
      commit(types.LOADING_NEW_DROPS, { isLoading: false, isExportLoading: true })
    }).catch((error) => {
      console.log(error)
    }).finally(() => {
      commit(types.LOADING_NEW_DROPS, { isLoading: false, isExportLoading: false })
    })
  },
  addDropUnit ({ commit }, { unit, dropID, units, previousUnits }) {
    commit(types.LOADING_NEW_DROPS, { isLoading: true })
    dropService.addUnit(unit).then((response) => {
      unit['id'] = response.data.addConsolidationUnit.id
      unit.children.forEach((children) => {
        children.parent = unit.id
      })
      previousUnits.push(unit)
      const newUnitsTree = previousUnits.filter(({ id }) => {
        return unit.units.indexOf(id) < 0
      })
      let totalVolume = 0
      newUnitsTree.forEach((unit, index) => {
        totalVolume += unit.dimensions.length * 0.01 * unit.dimensions.width * 0.01 * unit.dimensions.height * 0.01
      })
      commit(types.UPDATE_DROP_VOLUME_WEIGHT_ADD, { volume: totalVolume, weight: unit.weight })
      commit(types.ADD_DROP_UNITS, { units: newUnitsTree, isTree: true })
      commit(types.UPDATE_DROP_UNIT_TYPE_COUNT, { dropID })
      commit(types.LOADING_NEW_DROPS, { isLoading: false })
      commit('SHOW_SNACKBAR', { message: `${i18n.t(`packages_type.${unit.type}`)} Added`, color: 'success' })
    }).catch((error) => {
      console.error(error)
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
    })
  },
  toggleUnit ({ commit }, { unitID }) {
    commit(types.TOGGLE_UNIT, { unitID })
    commit(types.SET_AVAILABLE_PALLETS)
  },
  toggleShiftUnit ({ commit }, { unitID }) {
    commit(types.TOGGLE_SHIFT_UNIT, { unitID })
    commit(types.SET_AVAILABLE_PALLETS)
  },
  toggleAllUnits ({ commit }, { toggleState, units }) {
    commit(types.TOGGLE_ALL_UNITS, { toggleState, units })
    commit(types.SET_AVAILABLE_PALLETS)
  },
  selectUnit ({ commit }, { unit }) {
    commit(types.SELECT_UNIT, { unit })
  },
  changeUnitParentID ({ commit }, { oldParent, parent, units, containerID, oldIndicies, newIndicies, dropID }) {
    commit(types.CHANGE_UNIT_PARENT_ID, { oldParent, parent, units, oldIndicies, newIndicies, containerID })
    commit(types.UPDATE_DROP_UNIT_TYPE_COUNT, { dropID })
    units.forEach((unit) => {
      dropService.setParent({ id: unit.id, parent: parent }).then((response) => {
      }).catch((error) => {
        console.log(error)
      })
    })
  },
  removeUnit ({ commit }, { unitID, dropID }) {
    commit(types.LOADING_NEW_DROPS, { isLoading: true })
    commit(types.UPDATE_DROP_VOLUME_WEIGHT_REMOVE, { unitID, dropID })
    commit(types.REMOVE_UNIT, { unitID, dropID })
    commit(types.UPDATE_DROP_UNIT_TYPE_COUNT, { dropID })
    commit(types.LOADING_NEW_DROPS, { isLoading: false })
    commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.unit_deleted'), color: 'success' })
    dropService.removeUnit({ id: unitID }).catch((error) => {
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
      console.error(error)
    })
    commit(types.TOGGLE_ALL_UNITS, { toggleState: 'remove', units: [] })
  },
  hoverUnit ({ commit }, { hoveredID }) {
    commit(types.HOVERED_UNIT, { hoveredID })
  },
  sortedByChanged ({ commit }, { sortedBy }) {
    commit(types.SORT_DETAIL_UNITS, { sortedBy })
  },
  filterByChanged ({ commit }, { customerRef, orderRef, enable }) {
    if (customerRef !== undefined) {
      commit(types.FILTER_CUSTOMER_REF_DETAIL_UNITS, { customerRef, enable })
    }
    if (orderRef !== undefined) {
      commit(types.FILTER_ORDER_REF_DETAIL_UNITS, { orderRef, enable })
    }
  },
  filterDropByCategory ({ commit }, { category, enable }) {
    commit(types.FILTER_ITEM_CATEGORY_DETAIL_UNITS, { category, enable })
  },
  toggleDropOrder ({ commit }, { orderRef, toggleState }) {
    commit(types.TOGGLE_DROP_ORDER, { orderRef, toggleState })
  },
  setCustomName ({ commit }, { id, name, oldVal }) {
    commit(types.SET_CUSTOM_NAME, { id, name })
    commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.unit_name_updated'), color: 'success' })
    dropService.setCustomName({ id, name }).catch((error) => {
      console.log(error)
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
      commit(types.SET_CUSTOM_NAME, { id, oldVal })
    })
  },
  setCustomWeight ({ commit }, { id, packagingWeight, weight, oldVal }) {
    commit(types.SET_CUSTOM_WEIGHT, { id, weight, packagingWeight })
    commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.unit_weight_updated'), color: 'success' })
    dropService.setUnitWeight({ id, weight: packagingWeight }).catch((error) => {
      console.error(error)
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
      // commit(types.SET_CUSTOM_WEIGHT, { id, oldVal })
    })
  },
  setCustomDimensions ({ commit }, { id, dimensions, oldVal }) {
    commit(types.SET_CUSTOM_DIMENSIONS, { id, dimensions })
    commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.unit_dimensions_updated'), color: 'success' })
    dropService.setUnitDimensions({ id, dimensions }).catch((error) => {
      console.error(error)
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
      commit(types.SET_CUSTOM_DIMENSIONS, { id, oldVal })
    })
  },
  setCustomStatus ({ commit }, { id, status, oldVal }) {
    commit(types.SET_CUSTOM_STATUS, { id, status })
    commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.unit_status_updated'), color: 'success' })
    dropService.setUnitStatus({ id, status }).catch((error) => {
      console.error(error)
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
      commit(types.SET_CUSTOM_STATUS, { id, oldVal })
    })
  },
  setPalletCalculationWarnings ({ commit }, { unit }) {
    commit(types.SET_PALLET_CALCULATION_WARNINGS, { unit })
  },
  setSelectedDropDetails ({ commit }, { drop }) {
    commit(types.SELECT_DROP_DETAILS_VIEW, { drop })
  },
  setSelectedDropOriginLocation ({ commit }, { locationID }) {
    locationService.getLocation({ locationID }).then((response) => {
      commit(types.SET_SELECTED_DROP_ORIGIN_LOCATION, { location: response })
    })
  },
  setSelectedDropDestinationLocation ({ commit }, { locationID }) {
    locationService.getLocation({ locationID }).then((response) => {
      commit(types.SET_SELECTED_DROP_DESTINATION_LOCATION, { location: response })
    })
  }
}
export default actions
